export var safeProbe=function safeProbe(cb){try{return cb();}catch(e){return undefined;}};